import { Validators } from '@angular/forms';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { UNITS } from '@ordersnproducts/modules/shared/constants/units';
import { FormInputCheckboxComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-checkbox/form-input-checkbox.component';
import { FormInputNumberComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-number/form-input-number.component';
import {
  FieldConfig,
  NewLineField,
} from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldInputNumberConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-number-config.interface';
import { FormSelectComponent } from '../../../../../../../shared/modules/configurable-form/components/form-select/form-select.component';
import { FieldSelectConfig } from '../../../../../../../shared/modules/configurable-form/components/form-select/models/field-select-config.interface';
import { generateAddedValueFormName } from '../../../../helpers/form-added-value-name-generator';
import { AddedValueFieldConfig } from '../../../../models/form-added-value-field-config';
import { RmsFormConfig } from '../../../../models/rms-form-config';
import { CutOffEffects } from '../../../../effects/cut-off.effects';
import { FormInfoIconMessageComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-info-icon-message/form-info-icon-message.component';
import { DirectProjectProfilesOptionLoader } from '../../../../services/config-loader/loaders/direct-project-profile.service.loader';
import { SingleCatalogsEffects } from '../../../../effects/single-catalogs.effects';
import {
  SingleApplicationsLoaderService,
  SingleSlumpProductLoaderService,
  SingleSpacingsLoaderService,
} from '../../../../services/config-loader/loaders/single-catalogs.loader.service';
import { SetProjectPropertiesCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/set-project-properties.command';
import { SetProjectProfileSlumpCommand } from '../../../../services/config-loader/commands/set-project-profile-slump.command.service';
// product form field
import { ProductsOptionsLoaderOpenPlatformService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/loaders/open-platform/products.loader.service';
import { ProductsOpenPlatformEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/open-platform/products.effects';
import { ProductsDisablerOpenPlatformProvider } from '@ordersnproducts/modules/order-builder/modules/rms-specification/providers/open-platform/product-enabler.provider';
import { LoadSingleCatalogsProjectProfile } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/commands/single-catalogs-project-profile.command.service';
import { LoadProductAddedValuesNotFormulatingOpenPlatformCommandService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/commands/open-platform/load-added-value-not-formulating.command.service';
// quantity form field
import { RmsMaximumCapacityOpenPlatformProvider } from '@ordersnproducts/modules/order-builder/modules/rms-specification/providers/open-platform/rms-maximum-capacity.provider';
import { HandleRemainingBalanceOpenPlatformCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/open-plaftorm/handle-remaining-balance-validation.command';
// contract form field
// value addeds form fields
import { AddedValueOpenPlatformDisabler } from '@ordersnproducts/modules/order-builder/modules/rms-specification/providers/open-platform/added-value-enabler.provider';
import { AddedValuesLoaderOpenPlatformService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/loaders/open-platform/added-value.loader.service';
import { LoadChildAddedValuesNotFormulatingOpenPlatformCommandService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/commands/open-platform/load-added-value-not-formulating.command.service';
import { LoadSingleCatalogsUnloadType } from '../../../../services/config-loader/commands/single-catalogs-unload-type.command.service';
import { LoadSingleCatalogsApplication } from '../../../../services/config-loader/commands/single-catalogs-application.command.service';
import { LoadSingleCatalogsSpacing } from '../../../../services/config-loader/commands/single-catalogs-spacing.command.service';
import { LoadSingleCatalogsUnloadTime } from '../../../../services/config-loader/commands/single-catalogs-unload-time.command.service';
import { LoadSingleCatalogsLoadSize } from '../../../../services/config-loader/commands/single-catalogs-load-size.command.service';
import { LoadSingleCatalogsSlumpProduct } from '../../../../services/config-loader/commands/single-catalogs-SlumpProduct.command.service';
import { FormInputComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input/form-input.component';
import { SingleLoadSizesCreateLoaderService } from '../../../../services/config-loader/loaders/single-load-size-create.loader.service';
import { ResetSlotOpenPlatformCommandService } from '../../../../services/config-loader/commands/open-platform/reset-slot.command.service';
import { ContractsOptionLoaderOpenPlatformService } from '../../../../services/config-loader/loaders/open-platform/contract.loader.service';
import { ContractOptionsLoaderOpenPlatformProvider } from '../../../../providers/open-platform/contracts.provider';
import { contractVisibleFieldProvider } from '../../../../providers/contract-visible-field.provider';
import {
  ResetVapsAndContractOPCommandService,
  ResetVapsValueOPCommandService,
} from '../../../../services/config-loader/commands/open-platform/reset-added-value.command.service';
import {
  LoadTemperatureVapsService,
  ResetTemperatureFeatureService,
} from '../../../../services/config-loader/commands/temperature-loaders.service';
import { ResetUnloadTypeService } from '../../../../services/config-loader/commands/reset-unload-type.service';
import { LoadPumpPrimerValuesService } from '@ordersnproducts/modules/shared/modules/pump-primer/services/pump-primer.command.service';
import { LoadSingleCatalogsTemperature } from '../../../../services/config-loader/commands/single-catalogs-temperature.command.service';
import { ProductsOptionsLoaderOpenPlatformProvider } from '../../../../providers/open-platform/products-options.provider';
import { LoadContractOpenPlatformCommandService } from '../../../../services/config-loader/commands/open-platform/load-contract.command.service';
import { DateTimeEnablerProvider } from '../../../../providers/open-platform/date-time-enabler.provider';
import { ContractSecondaryTextProvider } from '@ordersnproducts/modules/multiple-order-online/modules/schedule-orders/providers/contract-secondary-text.provider';
import { SetAddedValueSpecializedCommandService } from '../../../../services/config-loader/commands/open-platform/set-added-value-specialized.command';
import { SpecFieldTestIds } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-test-ids.enum';

export const arkikUL = {
  canAddMultipleProducts: true,
  recipe: [
    {
      type: FormInputComponent,
      label: 'id',
      name: SpecFieldNames.ID,
      containerClassNames: ['d-none'],
      placeholder: 'id',
    } as FieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.product_description',
      name: SpecFieldNames.PRODUCT_SELECTION,
      dataTId: SpecFieldTestIds.PRODUCT_DESCRIPTION,
      containerClassNames: ['field-12x field-md-6x retail-control'],
      optionsLoader: ProductsOptionsLoaderOpenPlatformService,
      optionsProvider: ProductsOptionsLoaderOpenPlatformProvider,
      loading: ProductsDisablerOpenPlatformProvider.IsLoading,
      validation: [Validators.required],
      dynamicEffects: [ProductsOpenPlatformEffects, CutOffEffects],
      placeholder: 'views.specifications.select_product',
      onChange: [
        LoadSingleCatalogsUnloadType,
        LoadSingleCatalogsApplication,
        LoadSingleCatalogsSpacing,
        LoadSingleCatalogsUnloadTime,
        LoadSingleCatalogsSlumpProduct,
        LoadSingleCatalogsLoadSize,
        LoadContractOpenPlatformCommandService,
        LoadSingleCatalogsProjectProfile,
        ResetSlotOpenPlatformCommandService,
        ResetVapsAndContractOPCommandService,
      ],
      rehydrate: true,
    } as FieldSelectConfig,
    {
      type: FormInputNumberComponent,
      label: 'views.specifications.quantity',
      containerClassNames: ['field-11x field-md-2x retail-control'],
      name: SpecFieldNames.QUANTITY,
      dataTId: SpecFieldTestIds.QUANTITY,
      min: 1,
      value: 1,
      step: 1,
      max: RmsMaximumCapacityOpenPlatformProvider.RmsMaxCapacity,
      message: RmsMaximumCapacityOpenPlatformProvider.MessageUsa,
      suffix: UNITS.CUBIC_YARD,
      validation: [Validators.required],
      decimals: 1,
      onChange: [HandleRemainingBalanceOpenPlatformCommand],
    } as FieldInputNumberConfig,
    {
      type: FormInfoIconMessageComponent,
      name: SpecFieldNames.CONCRETE_MIN_QUANTITY_INFO,
      dataTId: SpecFieldTestIds.CONCRETE_MIN_QUANTITY_INFO,
      value: false,
      containerClassNames: ['field-1x field-md-1x retail-control'],
      text: 'views.specifications.special-message',
    } as FieldConfig,
    {
      type: FormInputCheckboxComponent,
      name: SpecFieldNames.ADJUSTMENT,
      dataTId: SpecFieldTestIds.ADJUSTMENT,
      value: false,
      containerClassNames: ['field-6x field-md-2x retail-control specification-adjustment'],
      placeholder: 'views.specifications.kicker',
    } as FieldConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.contract',
      name: SpecFieldNames.CONTRACT_SELECT,
      dataTId: SpecFieldTestIds.CONTRACT_SELECT,
      containerClassNames: ['field-12x field-md-6x retail-control'],
      optionsLoader: ContractsOptionLoaderOpenPlatformService,
      optionsProvider: ContractOptionsLoaderOpenPlatformProvider,
      placeholder: 'views.specifications.select_contract',
      visible: contractVisibleFieldProvider.Visible,
      validation: [Validators.required],
      secondaryTextTransform: ContractSecondaryTextProvider.RejectionCode,
      onChange: [
        ResetVapsValueOPCommandService,
        LoadTemperatureVapsService,
        LoadSingleCatalogsTemperature,
        LoadProductAddedValuesNotFormulatingOpenPlatformCommandService,
        ResetSlotOpenPlatformCommandService,
        ResetTemperatureFeatureService,
        ResetUnloadTypeService,
        LoadPumpPrimerValuesService,
      ],
      rehydrate: true,
    } as FieldSelectConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(0),
      dataTId: SpecFieldTestIds.VALUE_ADDED_FIRST,
      index: 0,
      loading: AddedValueOpenPlatformDisabler.IsLoading,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      optionsLoader: AddedValuesLoaderOpenPlatformService,
      onChange: [
        LoadChildAddedValuesNotFormulatingOpenPlatformCommandService,
        ResetSlotOpenPlatformCommandService,
        SetAddedValueSpecializedCommandService,
      ],
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(1),
      dataTId: SpecFieldTestIds.VALUE_ADDED_SECOND,
      index: 1,
      loading: AddedValueOpenPlatformDisabler.IsLoading,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      onChange: [
        LoadChildAddedValuesNotFormulatingOpenPlatformCommandService,
        ResetSlotOpenPlatformCommandService,
        SetAddedValueSpecializedCommandService,
      ],
      optionsLoader: AddedValuesLoaderOpenPlatformService,
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(2),
      dataTId: SpecFieldTestIds.VALUE_ADDED_THIRD,
      index: 2,
      loading: AddedValueOpenPlatformDisabler.IsLoading,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      onChange: [
        LoadChildAddedValuesNotFormulatingOpenPlatformCommandService,
        ResetSlotOpenPlatformCommandService,
        SetAddedValueSpecializedCommandService,
      ],
      optionsLoader: AddedValuesLoaderOpenPlatformService,
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(3),
      dataTId: SpecFieldTestIds.VALUE_ADDED_FOURTH,
      index: 3,
      loading: AddedValueOpenPlatformDisabler.IsLoading,
      limit: true,
      optionsLoader: AddedValuesLoaderOpenPlatformService,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
      onChange: [ResetSlotOpenPlatformCommandService, SetAddedValueSpecializedCommandService],
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.project_profiles',
      name: SpecFieldNames.PROJECT_PROFILES,
      dataTId: SpecFieldTestIds.PROJECT_PROFILES,
      containerClassNames: ['field-12x field-md-6x retail-control'],
      placeholder: 'views.specifications.select_projectProfiles',
      optionsLoader: DirectProjectProfilesOptionLoader,
      onChange: [SetProjectPropertiesCommand, SetProjectProfileSlumpCommand],
    } as FieldSelectConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.unload_type',
      name: SpecFieldNames.UNLOAD_TYPE,
      dataTId: SpecFieldTestIds.UNLOAD_TYPE,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'Direct Flow',
      value: 'DIRECT_FLOW',
      validation: [Validators.required],
      disabled: true,
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.application',
      name: SpecFieldNames.APPLICATION,
      dataTId: SpecFieldTestIds.APPLICATION,
      optionsLoader: SingleApplicationsLoaderService,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_application',
      validation: [Validators.required],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.spacing',
      name: SpecFieldNames.SPACING,
      dataTId: SpecFieldTestIds.SPACING,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      disabled: false,
      placeholder: 'views.specifications.select_spacing',
      optionsLoader: SingleSpacingsLoaderService,
      validation: [Validators.required],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.slump',
      name: SpecFieldNames.SLUMP_PRODUCT,
      dataTId: SpecFieldTestIds.SLUMP,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      disabled: false,
      placeholder: 'views.specifications.select_slump',
      optionsLoader: SingleSlumpProductLoaderService,
      validation: [Validators.required],
      dynamicEffects: [SingleCatalogsEffects],
      rehydrate: true,
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.load_size',
      name: SpecFieldNames.LOAD_SIZE,
      dataTId: SpecFieldTestIds.LOAD_SIZE,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_load_size',
      optionsLoader: SingleLoadSizesCreateLoaderService,
      disabled: false,
      validation: [Validators.required],
      onChange: [ResetSlotOpenPlatformCommandService],
    } as FieldSelectConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormInputComponent,
      label: SpecFieldNames.SCHEDULE_MOMENT,
      name: SpecFieldNames.SCHEDULE_MOMENT,
      dataTId: SpecFieldTestIds.SCHEDULE_MOMENT,
      placeholder: '',
      hidden: false,
      visible: false,
      validation: [Validators.required],
      disabled: DateTimeEnablerProvider.DisableScheduleMomentFormField,
    } as FieldConfig,
  ],
} as RmsFormConfig;
